import { render, staticRenderFns } from "./NullState.vue?vue&type=template&id=72a9a7a0&scoped=true&"
import script from "./NullState.vue?vue&type=script&lang=js&"
export * from "./NullState.vue?vue&type=script&lang=js&"
import style0 from "./NullState.vue?vue&type=style&index=0&id=72a9a7a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a9a7a0",
  null
  
)

export default component.exports